import { isHandyApp } from "@/app/utils/device";
export const isApp = isHandyApp;
